import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { getAppLanguage } from "helpers/getAppLanguage"

const lang = getAppLanguage();
console.log("lang ***", lang);

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: false,
    fallbackLng: lang.key,
    lng: lang.key,
    interpolation: { escapeValue: false },
    react: { useSuspense: false },

    // Backend config: include PUBLIC_URL to handle /admin/<buildnumber>
    backend: {
      loadPath: `${process.env.PUBLIC_URL || ''}/locales/{{lng}}/{{ns}}.json`,
    },

    // Language detection options (optional, but recommended)
    detection: {
      order: ['path', 'localStorage', 'navigator'],
      lookupFromPathIndex: 0,
      checkWhitelist: true,
    },
  });

export default i18n;
